module.exports = __webpack_public_path__ + "static/media/about-us.e11912fd.jpeg";